import React, { useEffect, useRef } from 'react';
import { features } from '../mock';
import { Brain, CloudRain, Sparkles, HandHeart } from 'lucide-react';

const iconMap = {
  brain: Brain,
  cloud: CloudRain,
  sparkle: Sparkles,
  'heart-hand': HandHeart,
};

const Features = () => {
  const ref = useRef(null);

  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add('is-visible');
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="services" ref={ref} className="py-20 md:py-28 paper-bg relative">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <p className="font-script text-2xl text-[#7a8a4c] mb-2">How I can help</p>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2c3f25] tracking-tight">
            Gentle support for what you’re carrying
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4">
            <span className="h-px w-10 bg-[#8fa05a]" />
            <span className="text-[#8fa05a]">❧</span>
            <span className="h-px w-10 bg-[#8fa05a]" />
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((f, i) => {
            const Icon = iconMap[f.icon];
            return (
              <div
                key={f.id}
                className="reveal group text-center px-4 py-8 md:py-10 rounded-2xl hover:bg-[#f0e9d2] transition-colors duration-300"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="feature-icon-bg w-20 h-20 md:w-24 md:h-24 rounded-full mx-auto flex items-center justify-center shadow-sm group-hover:shadow-md group-hover:-translate-y-1 transition-all duration-300">
                  <Icon className="text-[#3a5232]" size={36} strokeWidth={1.4} />
                </div>
                <h3 className="font-serif text-lg md:text-xl text-[#2c3f25] mt-6 leading-tight">
                  {f.title}
                  <br />
                  <span className="text-[#3d4a36]">{f.subtitle}</span>
                </h3>
                <p className="text-sm text-[#5a6a4a] mt-3 leading-relaxed max-w-[200px] mx-auto">
                  {f.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
